import React from 'react';

import { Typography } from '@mui/material';
import { useTimezone } from '@uplift/contexts';
import { CalendarDateService } from '@uplift/services';
import { SignatureCard } from './SignatureCard';


export const SignedConfirmationCard: React.VFC<{
  datetime: string;
  physicianName: string;
}> = ({ datetime, physicianName }) => {
  const timezone = useTimezone();

  return (
    <SignatureCard
      signed
      title={`You signed this on ${CalendarDateService.date(datetime).tz(timezone).format('MMM D, YYYY [at] h:mm A z')}`}
      chipLabel="Sent for counter-signature"
    >
      <Typography variant="body2">
        Sent to {physicianName} for counter-signature. It takes effect the day they sign.
      </Typography>
    </SignatureCard>
  );
};
